// ========================================
// 🎯 ACTION TYPES
// ========================================

// Metadata
export const GET_KPI_DASHBOARDS_METADATA_REQUEST = 'GET_KPI_DASHBOARDS_METADATA_REQUEST';
export const GET_KPI_DASHBOARDS_METADATA_SUCCESS = 'GET_KPI_DASHBOARDS_METADATA_SUCCESS';
export const GET_KPI_DASHBOARDS_METADATA_FAIL = 'GET_KPI_DASHBOARDS_METADATA_FAIL';

export const GET_KPI_SOURCES_METADATA_REQUEST = 'GET_KPI_SOURCES_METADATA_REQUEST';
export const GET_KPI_SOURCES_METADATA_SUCCESS = 'GET_KPI_SOURCES_METADATA_SUCCESS';
export const GET_KPI_SOURCES_METADATA_FAIL = 'GET_KPI_SOURCES_METADATA_FAIL';

export const GET_KPI_FIELDS_METADATA_REQUEST = 'GET_KPI_FIELDS_METADATA_REQUEST';
export const GET_KPI_FIELDS_METADATA_SUCCESS = 'GET_KPI_FIELDS_METADATA_SUCCESS';
export const GET_KPI_FIELDS_METADATA_FAIL = 'GET_KPI_FIELDS_METADATA_FAIL';

// Preview
export const GET_KPI_WIDGET_PREVIEW_REQUEST = 'GET_KPI_WIDGET_PREVIEW_REQUEST';
export const GET_KPI_WIDGET_PREVIEW_SUCCESS = 'GET_KPI_WIDGET_PREVIEW_SUCCESS';
export const GET_KPI_WIDGET_PREVIEW_FAIL = 'GET_KPI_WIDGET_PREVIEW_FAIL';

export const GET_KPI_DASHBOARD_PREVIEW_REQUEST = 'GET_KPI_DASHBOARD_PREVIEW_REQUEST';
export const GET_KPI_DASHBOARD_PREVIEW_SUCCESS = 'GET_KPI_DASHBOARD_PREVIEW_SUCCESS';
export const GET_KPI_DASHBOARD_PREVIEW_FAIL = 'GET_KPI_DASHBOARD_PREVIEW_FAIL';

// CRUD
export const CREATE_KPI_CONFIGURATION_REQUEST = 'CREATE_KPI_CONFIGURATION_REQUEST';
export const CREATE_KPI_CONFIGURATION_SUCCESS = 'CREATE_KPI_CONFIGURATION_SUCCESS';
export const CREATE_KPI_CONFIGURATION_FAIL = 'CREATE_KPI_CONFIGURATION_FAIL';

export const UPDATE_KPI_CONFIGURATION_REQUEST = 'UPDATE_KPI_CONFIGURATION_REQUEST';
export const UPDATE_KPI_CONFIGURATION_SUCCESS = 'UPDATE_KPI_CONFIGURATION_SUCCESS';
export const UPDATE_KPI_CONFIGURATION_FAIL = 'UPDATE_KPI_CONFIGURATION_FAIL';

export const DELETE_KPI_CONFIGURATION_REQUEST = 'DELETE_KPI_CONFIGURATION_REQUEST';
export const DELETE_KPI_CONFIGURATION_SUCCESS = 'DELETE_KPI_CONFIGURATION_SUCCESS';
export const DELETE_KPI_CONFIGURATION_FAIL = 'DELETE_KPI_CONFIGURATION_FAIL';

export const GET_ALL_KPI_CONFIGURATIONS_REQUEST = 'GET_ALL_KPI_CONFIGURATIONS_REQUEST';
export const GET_ALL_KPI_CONFIGURATIONS_SUCCESS = 'GET_ALL_KPI_CONFIGURATIONS_SUCCESS';
export const GET_ALL_KPI_CONFIGURATIONS_FAIL = 'GET_ALL_KPI_CONFIGURATIONS_FAIL';

// Runtime Data
export const GET_KPI_DASHBOARD_DATA_REQUEST = 'GET_KPI_DASHBOARD_DATA_REQUEST';
export const GET_KPI_DASHBOARD_DATA_SUCCESS = 'GET_KPI_DASHBOARD_DATA_SUCCESS';
export const GET_KPI_DASHBOARD_DATA_FAIL = 'GET_KPI_DASHBOARD_DATA_FAIL';

// ========================================
// 🎬 ACTION CREATORS
// ========================================

// Dashboards Metadata
export const getKpiDashboardsMetadataRequest = (moduleKey, roleKey) => ({
    type: GET_KPI_DASHBOARDS_METADATA_REQUEST,
    payload: { moduleKey, roleKey }
});
export const getKpiDashboardsMetadataSuccess = (dashboards) => ({
    type: GET_KPI_DASHBOARDS_METADATA_SUCCESS,
    payload: dashboards
});
export const getKpiDashboardsMetadataFail = (error) => ({
    type: GET_KPI_DASHBOARDS_METADATA_FAIL,
    error
});

// Sources Metadata
export const getKpiSourcesMetadataRequest = (moduleKey) => ({
    type: GET_KPI_SOURCES_METADATA_REQUEST,
    payload: { moduleKey }
});
export const getKpiSourcesMetadataSuccess = (sources) => ({
    type: GET_KPI_SOURCES_METADATA_SUCCESS,
    payload: sources
});
export const getKpiSourcesMetadataFail = (error) => ({
    type: GET_KPI_SOURCES_METADATA_FAIL,
    error
});

// Fields Metadata
export const getKpiFieldsMetadataRequest = (sourceKey) => ({
    type: GET_KPI_FIELDS_METADATA_REQUEST,
    payload: { sourceKey }
});
export const getKpiFieldsMetadataSuccess = (fields) => ({
    type: GET_KPI_FIELDS_METADATA_SUCCESS,
    payload: fields
});
export const getKpiFieldsMetadataFail = (error) => ({
    type: GET_KPI_FIELDS_METADATA_FAIL,
    error
});

// Widget Preview
export const getKpiWidgetPreviewRequest = (config) => ({
    type: GET_KPI_WIDGET_PREVIEW_REQUEST,
    payload: config
});
export const getKpiWidgetPreviewSuccess = (preview) => ({
    type: GET_KPI_WIDGET_PREVIEW_SUCCESS,
    payload: preview
});
export const getKpiWidgetPreviewFail = (error) => ({
    type: GET_KPI_WIDGET_PREVIEW_FAIL,
    error
});

// Dashboard Preview
export const getKpiDashboardPreviewRequest = (dashboardKey, config) => ({
    type: GET_KPI_DASHBOARD_PREVIEW_REQUEST,
    payload: { dashboardKey, config }
});
export const getKpiDashboardPreviewSuccess = (preview) => ({
    type: GET_KPI_DASHBOARD_PREVIEW_SUCCESS,
    payload: preview
});
export const getKpiDashboardPreviewFail = (error) => ({
    type: GET_KPI_DASHBOARD_PREVIEW_FAIL,
    error
});

// Configurations CRUD
export const createKpiConfigurationRequest = (data) => ({
    type: CREATE_KPI_CONFIGURATION_REQUEST,
    payload: data
});
export const createKpiConfigurationSuccess = (config) => ({
    type: CREATE_KPI_CONFIGURATION_SUCCESS,
    payload: config
});
export const createKpiConfigurationFail = (error) => ({
    type: CREATE_KPI_CONFIGURATION_FAIL,
    error
});

export const updateKpiConfigurationRequest = (id, data) => ({
    type: UPDATE_KPI_CONFIGURATION_REQUEST,
    payload: { id, data }
});
export const updateKpiConfigurationSuccess = (config) => ({
    type: UPDATE_KPI_CONFIGURATION_SUCCESS,
    payload: config
});
export const updateKpiConfigurationFail = (error) => ({
    type: UPDATE_KPI_CONFIGURATION_FAIL,
    error
});

export const deleteKpiConfigurationRequest = (id) => ({
    type: DELETE_KPI_CONFIGURATION_REQUEST,
    payload: { id }
});
export const deleteKpiConfigurationSuccess = (id) => ({
    type: DELETE_KPI_CONFIGURATION_SUCCESS,
    payload: id
});
export const deleteKpiConfigurationFail = (error) => ({
    type: DELETE_KPI_CONFIGURATION_FAIL,
    error
});

export const getAllKpiConfigurationsRequest = () => ({
    type: GET_ALL_KPI_CONFIGURATIONS_REQUEST
});
export const getAllKpiConfigurationsSuccess = (configs) => ({
    type: GET_ALL_KPI_CONFIGURATIONS_SUCCESS,
    payload: configs
});
export const getAllKpiConfigurationsFail = (error) => ({
    type: GET_ALL_KPI_CONFIGURATIONS_FAIL,
    error
});

// Dashboard Runtime Data
export const getKpiDashboardDataRequest = (dashboardKey, runtimeFilters = {}) => ({
    type: GET_KPI_DASHBOARD_DATA_REQUEST,
    payload: { dashboardKey, runtimeFilters }
});
export const getKpiDashboardDataSuccess = (data) => ({
    type: GET_KPI_DASHBOARD_DATA_SUCCESS,
    payload: data
});
export const getKpiDashboardDataFail = (error) => ({
    type: GET_KPI_DASHBOARD_DATA_FAIL,
    error
});
